import {RefObject, useRef, useState} from 'react';

import {isNil} from 'ramda';

import {Nullish} from 'shared/web';

import {
  createTemplateTokenSuggestionMenu,
  TemplateTokenSuggestionMenuState,
} from '../templateTokens/createTemplateTokenSuggestionMenu';
import {RichTextTemplateTokenSuggestions} from '../types';

/**
 * The `/` menu of a rich text editor in token mode. Whether it exists is fixed on mount; the items
 * are read at each keystroke, so they may arrive after the editor.
 */
export function useTemplateTokenSuggestions(
  suggestions: RichTextTemplateTokenSuggestions | Nullish,
  anchorParentRef: RefObject<HTMLElement | null>
) {
  const itemsRef = useRef(suggestions?.items);
  itemsRef.current = suggestions?.items;

  const [menuState, setMenuState] = useState<TemplateTokenSuggestionMenuState | null>(null);
  const [menu] = useState(() =>
    isNil(suggestions)
      ? null
      : createTemplateTokenSuggestionMenu({
          getItems: () => itemsRef.current ?? [],
          getAnchorParent: () => anchorParentRef.current,
          onStateChange: setMenuState,
        })
  );

  return {menu, menuState};
}
